import { createContext } from "react";
import type { ExercisesContextType } from "../ExercisesProvider.types";

const ExercisesContext = createContext<ExercisesContextType | undefined>(undefined);
ExercisesContext.displayName = "ExercisesContext";

export default ExercisesContext;
